"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SourceSettings = require("./SourceSettings");
Object.keys(_SourceSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SourceSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SourceSettings[key];
    }
  });
});
var _CameraSourceSettings = require("./CameraSourceSettings");
Object.keys(_CameraSourceSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CameraSourceSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CameraSourceSettings[key];
    }
  });
});
var _GenericCameraSourceSettings = require("./GenericCameraSourceSettings/GenericCameraSourceSettings");
Object.keys(_GenericCameraSourceSettings).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenericCameraSourceSettings[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GenericCameraSourceSettings[key];
    }
  });
});